import { render, staticRenderFns } from "./VNode.vue?vue&type=template&id=439cc6ec&"
import script from "./VNode.vue?vue&type=script&lang=ts&"
export * from "./VNode.vue?vue&type=script&lang=ts&"
import style0 from "./VNode.vue?vue&type=style&index=0&id=439cc6ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports